import { useEffect } from "react";
import { connect } from "react-redux";
import Intercom from "@intercom/messenger-js-sdk";
import StorageGateway from "lib/storage-gateway";
import * as UserDucks from "ducks/accounts/user";

const ChatBot = ({ profile, userFullName, isBusinessAdmin }) => {
  const userId = StorageGateway.get("userId");

useEffect(() => {
  if (
    !profile ||
    Object.keys(profile).length === 0 ||
    !userId ||
    userId === "null"
  ) {
    if (window.Intercom) window.Intercom("shutdown");
    return;
  }
  const canShowChatBot =
    isBusinessAdmin || profile?.company?.id === 2;

  if (!canShowChatBot) {
    if (window.Intercom) window.Intercom("shutdown");
    return;
  }

  // --- Boot Intercom ---
  const payload = {
    app_id: "wyd2yvj2",
    user_id: userId,
    vertical_padding: 30,
  };

  if (userFullName) payload.name = userFullName;
  else if (profile.username) payload.name = profile.username;

  if (profile.email) payload.email = profile.email;
  if (profile.date_joined) {
    payload.created_at = Math.floor(
      new Date(profile.date_joined).getTime() / 1000
    );
  }

  Intercom(payload);
}, [profile, userId, isBusinessAdmin, userFullName]);


  return null;
};

const mapStateToProps = (state) => ({
  userFullName: UserDucks.userFullName(state),
  profile: UserDucks.profile(state),
  isBusinessAdmin: UserDucks.isLoggedInAdmin(state),
});

export default connect(mapStateToProps)(ChatBot);
